'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M448 832l288-288-288-288v192h-448v192h448v192z' }),
        React.createElement('path', { d: 'M960 1024h-704v-128h640v-704h-640v-128h704c35.346 0 64 28.654 64 64v832c0 35.346-28.654 64-64 64z' })
    ));
};